import { RefObject, useEffect, useRef } from 'react';

export const useClickOutside = (
  ref: RefObject<HTMLElement>,
  onClickOutside: () => void,
  { enabled = false }: { enabled?: boolean } = {}
): void => {
  const onClickOutsideRef = useRef(onClickOutside);
  onClickOutsideRef.current = onClickOutside;

  useEffect(() => {
    if (!enabled) return undefined;

    function handleClickOutside(e: globalThis.MouseEvent): void {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        onClickOutsideRef.current();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [ref, enabled]);
};
